import auth from './modules/auth/src';
import membership from './modules/membership/src';

export default [auth, membership];
